import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Client, Trade } from '../types';
import { clientService } from '../services/client.service';
import { tradeService } from '../services/trade.service';
import { TradeDialog } from '../components/common/TradeDialog';

export function TradeEntry() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [clients, setClients] = useState<Client[]>([]);
  const [editTrade, setEditTrade] = useState<Trade | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientsData = await clientService.getClients(true);
        setClients(clientsData);

        if (id) {
          const trade = await tradeService.getTradeById(id);
          setEditTrade(trade);
        }
      } catch (err) {
        console.error('Failed to load data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
        <CircularProgress />
        <Typography ml={2} color="text.secondary">Loading...</Typography>
      </Box>
    );
  }

  return (
    <TradeDialog
      key={editTrade ? editTrade.tradeId : 'new'}
      open={true}
      onClose={() => navigate(-1)}
      onSuccess={() => navigate('/trades')}
      clients={clients}
      editTrade={editTrade}
    />
  );
}

export default TradeEntry;
